import React from "react";

// Define the type for the component's props if you wanted to make the URL dynamic
interface ContentDashboardEmbedProps {
  // If you want to allow different URLs, define them here:
  // srcUrl: string;
  // title: string;
}

const ContentDashboard: React.FC<ContentDashboardEmbedProps> = () => {
  const embedUrl =
    "https://intact-angler.metabaseapp.com/public/dashboard/9c2ce10d-09f4-4f6f-9979-dfc0cc44ca33";

  return (
    <>
      <iframe
        src={embedUrl}
        title="Sports Dashboard"
        frameBorder="0"
        allowFullScreen
        style={{ width: "100%", height: "100vh", border: "none" }}
      ></iframe>
    </>
  );
};

export default ContentDashboard;
